export const Roles = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  CS_ADMIN: 'cs_admin',
  MANAGER: 'manager'
};

export const PermissionGroupName = {
  NEWS: 'news',
  WORKFLOW: 'workflow',
  WORKFLOW_CONFIGURATION: 'workflow-configuration',
  USER: 'user',
  COMPANY: 'company',
  COMPANIES: 'companies',
  TEMPLATE: 'template',
  SUPER_ADMIN: 'super-admin',
  DASHBOARD: 'dashboard',
  LIEN: 'lien',
  RENTER: 'renter',
  TEAM: 'team',
  ADD_LOCATION: 'add-location',
  REPORTS: 'reports',
  DOC_UPLOAD: 'doc-upload'
};

export const PermissionLevel = {
  READ: 'read',
  MODIFY: 'modify',
  CREATE: 'create',
  DELETE: 'delete'
};

export const Permissions = {
  [Roles.SUPER_ADMIN]: {
    [PermissionGroupName.DOC_UPLOAD]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.REPORTS]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.NEWS]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.WORKFLOW]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.USER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.COMPANY]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.TEMPLATE]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.DASHBOARD]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.WORKFLOW_CONFIGURATION]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.LIEN]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.RENTER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.TEAM]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.COMPANIES]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.ADD_LOCATION]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    }
  },
  [Roles.ADMIN]: {
    [PermissionGroupName.NEWS]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.WORKFLOW]: {
      [PermissionLevel.READ]: false,
      [PermissionLevel.MODIFY]: false,
      [PermissionLevel.CREATE]: false,
      [PermissionLevel.DELETE]: false
    },
    [PermissionGroupName.USER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.COMPANY]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.TEMPLATE]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.DASHBOARD]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.WORKFLOW_CONFIGURATION]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.LIEN]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.RENTER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.ADD_LOCATION]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    }
  },
  [Roles.CS_ADMIN]: {
    [PermissionGroupName.DOC_UPLOAD]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.NEWS]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.WORKFLOW]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.USER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.COMPANY]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.TEMPLATE]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.DASHBOARD]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.WORKFLOW_CONFIGURATION]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.LIEN]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.RENTER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.ADD_LOCATION]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    }
  },
  [Roles.MANAGER]: {
    [PermissionGroupName.DASHBOARD]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.RENTER]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    },
    [PermissionGroupName.TEMPLATE]: {
      [PermissionLevel.READ]: true,
      [PermissionLevel.MODIFY]: true,
      [PermissionLevel.CREATE]: true,
      [PermissionLevel.DELETE]: true
    }
  }
};
